import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "alert alert-warning" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "card mb-6" }
const _hoisted_6 = { class: "card-body card-body-sm" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col d-flex align-items-center" }
const _hoisted_9 = { class: "text-muted" }
const _hoisted_10 = { class: "col d-flex align-items-center" }
const _hoisted_11 = { class: "text-muted" }
const _hoisted_12 = { class: "col d-flex align-items-center" }
const _hoisted_13 = { class: "text-muted" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode()
const _hoisted_15 = { class: "ms-1" }
const _hoisted_16 = { class: "col d-flex align-items-center" }
const _hoisted_17 = { class: "text-muted" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "ms-1" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "row mb-6" }
const _hoisted_22 = { class: "col" }
const _hoisted_23 = { class: "card" }
const _hoisted_24 = { class: "card-body text-center" }
const _hoisted_25 = { class: "col" }
const _hoisted_26 = { class: "card" }
const _hoisted_27 = { class: "card-body text-center" }
const _hoisted_28 = { class: "col" }
const _hoisted_29 = { class: "card" }
const _hoisted_30 = { class: "card-body text-center" }
const _hoisted_31 = { class: "col" }
const _hoisted_32 = { class: "card" }
const _hoisted_33 = { class: "card-body text-center" }
const _hoisted_34 = { class: "row mb-6 justify-content-end" }
const _hoisted_35 = { class: "col-lg-3" }
const _hoisted_36 = { class: "card" }
const _hoisted_37 = { class: "card-body text-center" }
const _hoisted_38 = { class: "text-center" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_40 = { class: "card" }
const _hoisted_41 = { class: "card-body card-body-sm" }
const _hoisted_42 = { class: "container" }
const _hoisted_43 = { class: "row align-items-center" }
const _hoisted_44 = {
  key: 0,
  class: "col d-flex justify-content-center"
}
const _hoisted_45 = { class: "col d-flex justify-content-center" }
const _hoisted_46 = {
  key: 1,
  class: "col d-flex justify-content-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ApplicationStateComponent = _resolveComponent("ApplicationStateComponent")!
  const _component_ValidityOfCertificateComponent = _resolveComponent("ValidityOfCertificateComponent")!
  const _component_ProgressWheel = _resolveComponent("ProgressWheel")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ModalTitle = _resolveComponent("ModalTitle")!
  const _component_ModalHeader = _resolveComponent("ModalHeader")!
  const _component_ModalBody = _resolveComponent("ModalBody")!
  const _component_ModalFooter = _resolveComponent("ModalFooter")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_MainOverviewContainer = _resolveComponent("MainOverviewContainer")!

  return (_openBlock(), _createBlock(_component_MainOverviewContainer, null, {
    title: _withCtx(() => [
      (_ctx.hasCurrentApplication)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("h1", {
              innerHTML: _ctx.$t('text.header', { currentPeriod: _ctx.getCurrentApplicationPeriod(_ctx.periodOfApplication) })
            }, null, 8, _hoisted_1),
            _createElementVNode("p", {
              innerHTML: _ctx.$t('text.headline_subtitle', { area: _ctx.getAreaOfCompany(_ctx.organization) ? _ctx.$t(_ctx.getAreaOfCompany(_ctx.organization)) : '' }),
              class: "lead"
            }, null, 8, _hoisted_2)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t('meta.pageTitles.overview')), 1),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('text.is_loading')), 1)
          ], 64))
    ]),
    content: _withCtx(() => [
      (_ctx.hasCurrentApplication && _ctx.application)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('application.state')) + ": ", 1),
                    _createVNode(_component_ApplicationStateComponent, {
                      state: _ctx.application.state
                    }, null, 8, ["state"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('application.validity_award')) + ": ", 1),
                    _createVNode(_component_ValidityOfCertificateComponent, {
                      id: _ctx.applicationId,
                      validity: _ctx.getCurrentCertificateValidity(_ctx.organization)
                    }, null, 8, ["id", "validity"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('application.current_deadline')) + ":", 1),
                    _hoisted_14,
                    _createElementVNode("strong", _hoisted_15, _toDisplayString(_ctx.getDate(_ctx.application.deadline)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('application.last_modified')) + ": ", 1),
                    (_ctx.application.last_modified)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                          _createElementVNode("strong", _hoisted_19, _toDisplayString(_ctx.getDate(_ctx.application.last_modified)), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_20, "-"))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_ProgressWheel, {
                      state: _ctx.getStateOfForm(_ctx.generalInformationForm)
                    }, null, 8, ["state"]),
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('action_fields.basic_information')), 1),
                    _createVNode(_component_router_link, {
                      to: { name: 'FormView', params: { id: _ctx.generalInformationForm.id }},
                      class: "btn btn-secondary-alt-01-15 stretched-link"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('text.edit')), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_ProgressWheel, {
                      state: _ctx.getStateOfApplicationForm(_ctx.statisticalInformationForm, _ctx.organization, _ctx.statisticFormUploadFiles.length)
                    }, null, 8, ["state"]),
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('action_fields.statistical_information')), 1),
                    _createVNode(_component_router_link, {
                      to: { name: 'FormView', params: { id: _ctx.statisticalInformationForm.id }},
                      class: "btn btn-secondary-alt-02-15 stretched-link"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('text.edit')), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_ProgressWheel, {
                      state: _ctx.getStateOfForm(_ctx.basicUnderstandingForm)
                    }, null, 8, ["state"]),
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('action_fields.our_base_values')), 1),
                    _createVNode(_component_router_link, {
                      to: { name: 'FormView', params: { id: _ctx.basicUnderstandingForm.id }},
                      class: "btn btn-secondary-alt-03-15 stretched-link"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('text.edit')), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_ProgressWheel, {
                      state: _ctx.getFieldsOfActionState()
                    }, null, 8, ["state"]),
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('action_fields.title')), 1),
                    _createVNode(_component_router_link, {
                      to: { name: 'FieldOfActionOverview', params: { id: _ctx.applicationId }},
                      class: "btn btn-secondary-alt-04-15 stretched-link"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('text.edit')), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('meta.pageTitles.actions_overview')), 1),
                    _createVNode(_component_router_link, {
                      to: { name: 'ApplicationActionOverview', params: { id: _ctx.applicationId }},
                      class: "btn btn-secondary-alt-04-15 stretched-link",
                      "active-class": "active"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('text.edit')), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('text.finish_application_requirements')), 1),
              _hoisted_39
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    (!_ctx.applicationInReadonlyMode(_ctx.application, this.currentApplicationPeriod))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _createVNode(_component_router_link, {
                            to: { name: 'OrganizationDetails' },
                            class: "btn btn-secondary"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('text.button.upload_logo')), 1)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_45, [
                      _createVNode(_component_router_link, {
                        to: { name: 'PrintView', params: { id: _ctx.applicationId }},
                        class: "btn btn-secondary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('text.button.print_application')), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    (!_ctx.applicationInReadonlyMode(_ctx.application, this.currentApplicationPeriod))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _createVNode(_component_Button, {
                            "btn-style": "btn-secondary",
                            "btn-type": "button",
                            onClick: _withModifiers(_ctx.showFinishApplicationModal, ["prevent"])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('text.button.finish_application')), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.hasCurrentApplication && _ctx.application && !_ctx.applicationInReadonlyMode(_ctx.application, _ctx.currentApplicationPeriod))
        ? (_openBlock(), _createBlock(_component_Modal, {
            key: 1,
            id: _ctx.finishApplicationModalId,
            ref: "finishApplicationModal"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ModalHeader, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ModalTitle, {
                    title: _ctx.$t('text.finish_application_modal_header')
                  }, null, 8, ["title"])
                ]),
                _: 1
              }),
              _createVNode(_component_ModalBody, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('text.finish_application_submitting_note')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ModalFooter, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Button, {
                    "btn-style": "btn-secondary w-100",
                    "btn-type": "button",
                    onClick: _withModifiers(_ctx.finishApplication, ["prevent"])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('text.finish_application_finally')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["id"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}